import * as moment from 'moment';
import * as psl from 'psl';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { checkUncheck as checkUncheckAction } from "../../actions/mailActions";
import UserSettings from '../settings/model/Settings';
import Message from './model/Message';
import * as MessageUtil from './util/message.util';

interface IMessageItemMobileProps {
  message: Message;
  messageList: Message[];
  settings: UserSettings;
  releaseMode: boolean;
  deleteMode: boolean;
  checkUncheck: (messages: Message[]) => any;
}

interface IMessageItemMobileState {
  attachments: string[];
}

export class MessageItemMobile extends React.Component<IMessageItemMobileProps, IMessageItemMobileState> {

  constructor(props: IMessageItemMobileProps) {
    super(props);
    this.state = { attachments: [] };
    this.checkboxHandler = this.checkboxHandler.bind(this);
  }

  public checkboxHandler() {
    const selectedMessages = this.props.messageList.map((m) => {
      return { ...m, selected: m.id === this.props.message.id ? !m.selected : m.selected };
    })
    this.props.checkUncheck(selectedMessages);
  }

  public render() {
    const { message, settings } = this.props;
    const dateFormat = settings.dateFormat ? settings.dateFormat.toUpperCase() + ' hh:mm A' : 'MM/DD/YYYY hh:mm A';
    const unmatchingRootDomains = MessageUtil.hasUnmatchingDomains(message.headers.from, message.headers["return-path"]);
    const returnPathDomain = message.headers && message.headers["return-path"] && message.headers["return-path"].indexOf('@') >= 0 ? message.headers["return-path"].toLowerCase().split('@')[1].replace('>', '').trim() : undefined;
    const returnPathRootDomain = returnPathDomain ? psl.get(returnPathDomain) : "Unknown";
    const selectionMode = this.props.deleteMode || this.props.releaseMode;

    let returnPath = message.headers['return-path'] || "";
    returnPath = returnPath.replace(/<|>/g,'')

    if (message) {
      const messageItemStyle = { color: '#2a2a2a', 'textDecoration': 'none', width: '100%', 'paddingRight': '10px' };
      return (
        <div className="email-item">
          {selectionMode && <div className="select" id="selectCircleContainer" onClick={this.checkboxHandler}>
            <svg height="35" width="35">
              <circle data-type="selectCircle" className={message.selected ? this.props.releaseMode ? "circle-release-selected" : "circle-remove-selected" : this.props.deleteMode ? "circle-remove-border" : "circle-release-border"} cx="18" cy="18" r="15" />
            </svg>
          </div>}
          <a className="column" id="expand" style={messageItemStyle} data-toggle="collapse" data-target="#narrow-results" key={message.id}>
            <div className="email-header">
              <h6 className="from">{message.headers.from || returnPath}
              </h6>
              <span className="date">{moment(message.headers.date).format(dateFormat)}</span>
            </div>
            {unmatchingRootDomains && returnPathDomain && <div className="to-attach">
              <span>
                <FormattedMessage id="L.SentFrom" defaultMessage="sent from" />
                &nbsp;{returnPathRootDomain}
              </span>
            </div>}
            <div className="to-attach">
              <span>{message.headers.to}</span>
              {message.hasAttachment && <i className="material-icons attachment">attach_file</i>}
            </div>
            <div className="email-preview">
              <h6 className="subject">&lt;{message.headers.subject}&gt;</h6>
            </div>
          </a>
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = (state: any) => {
  return {
    deleteMode: state.mail.deleteMode,
    messageList: state.mail.messageList,
    releaseMode: state.mail.releaseMode,
    settings: state.settings.settings,
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    checkUncheck: bindActionCreators(checkUncheckAction, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageItemMobile);





// WEBPACK FOOTER //
// ./src/components/mail/MessageItemMobile.tsx